import { constant, Decoder, oneOf } from '@mojotech/json-type-validation'

import { ProgramLanguageType } from '@/domain/value_objects/language/programLanguageType'

export const programLanguageTypeDecoder: Decoder<ProgramLanguageType> = oneOf(
  constant<ProgramLanguageType>('C'),
  constant<ProgramLanguageType>('C++'),
  constant<ProgramLanguageType>('C++11'),
  constant<ProgramLanguageType>('C++14'),
  constant<ProgramLanguageType>('C++17'),
  constant<ProgramLanguageType>('C++20'),
  constant<ProgramLanguageType>('C++23'),
  constant<ProgramLanguageType>('C++20'),
  constant<ProgramLanguageType>('C++23'),
  constant<ProgramLanguageType>('JAVA'),
  constant<ProgramLanguageType>('D'),
  constant<ProgramLanguageType>('C#'),
  constant<ProgramLanguageType>('Scala'),
  constant<ProgramLanguageType>('Python'),
  constant<ProgramLanguageType>('Python3'),
  constant<ProgramLanguageType>('PyPy3'),
  constant<ProgramLanguageType>('Ruby'),
  constant<ProgramLanguageType>('JavaScript'),
  constant<ProgramLanguageType>('Rust'),
  constant<ProgramLanguageType>('Go'),
  constant<ProgramLanguageType>('Kotlin'),
  constant<ProgramLanguageType>('PHP'),
  constant<ProgramLanguageType>('Haskell'),
  constant<ProgramLanguageType>('OCaml')
)
